import * as React from "react";
import {Header} from "../components/Header";
import {t} from "i18next";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";

export const HelpEachOther = () => {
    const navigate = useNavigate();
    const {isAuthenticated} = useAuth();

    useEffect(() => {
        if (!isAuthenticated) {
            navigate("/login", {
                replace: true,
            });
        }
    }, []);

    return (
        <div className={"w-[100vw] bg-white flex flex-col items-center justify-center"}>
            <Header/>
            <img
                src="/banners/banner-ekmekana-madat-kara.jpg"
                alt=""
                className="w-full object-cover shadow-lg"
            />
            <h1 className={"text-[5vw] font-custom-mono-bold"}>{t("CONSTANTS.COMING_SOON")}</h1>
        </div>
    )
}
